import { ColumnsType, Text } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { DASH } from 'modules/constants'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { CompanyLink } from 'views/components/CompanyLink/CompanyLink'
import { UserLink } from 'views/components/UserLink/UserLink'
import { SumType } from './types'
import formatNumber from 'modules/utils/numbers/formatNumber'

export const useColumns = (sumData?: SumType): ColumnsType => {
  const { t } = useTranslation(['user'])
  const formatDate = useFormatDate()

  return useMemo(
    () =>
      [
        {
          title: t('productDataLabels.seller'),
          width: 300,
          dataIndex: 'user',
          render: (user, row: any) => (
            <div>
              <div>
                <UserLink user={user}>{user?.full_name}</UserLink>
              </div>
              <div>
                <CompanyLink company={row.company} />
              </div>
            </div>
          ),
        },
        {
          title: t('productDataLabels.product'),
          width: 180,
          dataIndex: 'product',
          render: (product) => product?.title,
        },
        {
          title: t('productDataLabels.region'),
          width: 150,
          dataIndex: 'region',
          render: (region) => region?.name,
        },
        {
          title: () => {
            const percent = sumData?.sowed_area_coverage_percent ? `${sumData.sowed_area_coverage_percent}%` : undefined
            return (
              <>
                {t('productDataLabels.sowed_area')}
                <Text typography="accentMedium" color="secondary">
                  {sumData?.sowed_area ? [percent, formatNumber(sumData?.sowed_area)].filter(Boolean).join(', ') : DASH}
                </Text>
              </>
            )
          },
          onHeaderCell: () => ({
            //withSubTitle: true,
          }),
          width: 140,
          dataIndex: 'sowed_area',
          align: 'right',
          sorter: true,
          render: (value) => formatNumber(value),
        },
        {
          title: () => (
            <>
              {t('productDataLabels.potential_quantity')}
              <Text typography="accentMedium" color="secondary">
                {sumData?.potential_quantity ? formatNumber(sumData?.potential_quantity) : DASH}
              </Text>
            </>
          ),
          onHeaderCell: () => ({
            withSubTitle: true,
          }),
          width: 110,
          dataIndex: 'potential_quantity',
          align: 'right',
          render: (value) => formatNumber(value),
        },
        {
          title: () => (
            <>
              {t('productDataLabels.actual_quantity_left')}
              <Text typography="accentMedium" color="secondary">
                {sumData?.actual_quantity_left ? formatNumber(sumData?.actual_quantity_left) : DASH}
              </Text>
            </>
          ),
          onHeaderCell: () => ({
            withSubTitle: true,
          }),
          width: 100,
          dataIndex: 'actual_quantity_left',
          align: 'right',
          render: (value) => formatNumber(value),
        },
        {
          title: t('productDataLabels.statCropYield'),
          width: 200,
          dataIndex: 'crop_stats',
          render: (crop_stats) => crop_stats?.capacity_in_ton,
          align: 'right',
        },
        {
          title: t('productDataLabels.modified'),
          width: 180,
          dataIndex: 'modified',
          render: (date) => formatDate(date, { withTime: true }),
          sorter: true,
        },
        {
          title: t('productDataLabels.sampleDate'),
          autoWidth: 180,
          dataIndex: 'sample_published_date',
          render: (date) => date && formatDate(date),
        },
      ] as ColumnsType<any>,
    [t, sumData, formatDate],
  )
}
